(function (w) {
	'use strict';

	/**
	 * @ngdoc enum
	 * @name mx.SolutionBuilderAgent.SearchQueryLogicalOperator
	 * @module mx.SolutionBuilderAgent
	 *
	 * @description
	 * Logical operators enumerable
	 */
	var mxSearchQueryLogicalOperator = {
		/**
		 * @ngdoc property
		 * @name mx.SolutionBuilderAgent.SearchQueryLogicalOperator#AND
		 *
		 * @description
		 * Logical operator And
		 */
		AND: 1,

		/**
		 * @ngdoc property
		 * @name mx.SolutionBuilderAgent.SearchQueryLogicalOperator#OR
		 *
		 * @description
		 * Logical operator Or
		 */
		OR: 2,
	};

	var mxSearchQueryTypeView = {
		/**
		 * @ngdoc property
		 * @name mx.SolutionBuilderAgent.SearchQueryLogicalOperator#AND
		 *
		 * @description
		 * Logical operator And
		 */
		Full: 1,

		/**
		 * @ngdoc property
		 * @name mx.SolutionBuilderAgent.SearchQueryLogicalOperator#OR
		 *
		 * @description
		 * Logical operator Or
		 */
		Short: 2,
	};

	w.mx = w.mx || {};
	w.mx.SolutionBuilderAgent = w.mx.SolutionBuilderAgent || {};
	w.mx.SolutionBuilderAgent.SearchQueryLogicalOperator = mxSearchQueryLogicalOperator;
	w.mx.SolutionBuilderAgent.SearchQueryTypeView = mxSearchQueryTypeView;
})(window);
